import { render, staticRenderFns } from "./ShelfTask.vue?vue&type=template&id=09b6eb78"
import script from "./ShelfTask.vue?vue&type=script&lang=js"
export * from "./ShelfTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports